import { render, staticRenderFns } from "./DictsListAttribute.vue?vue&type=template&id=441d5dc0"
import script from "./DictsListAttribute.vue?vue&type=script&lang=js"
export * from "./DictsListAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports